import { object, string } from 'yup'

const feedbackScheme = object().shape({
  field: string().max(200, 'feedbackMaxLength'),
})

export default feedbackScheme
